import { useEffect } from "react";
export const useOnKeyPress = (keyCode, onPress) => {
  useEffect(() => {
    let keyCodes = [];
    if (typeof keyCode === "string") {
      keyCodes = [keyCode];
    } else {
      keyCodes = keyCode;
    }
    const escList = ev => {
      if (keyCodes.includes(ev.key)) {
        onPress();
      }
    };
    document.addEventListener("keydown", escList);
    return () => {
      document.removeEventListener("keydown", escList);
    };
  }, [onPress, keyCode]);
};